import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { SettingService } from 'src/app/shared/services/setting.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-tenant-404-page',
    templateUrl: './tenant-404-page.component.html',
    styleUrls: ['./tenant-404-page.component.scss'],
    standalone: false
})
export class Tenant404PageComponent implements OnInit {

  isError404: boolean = false;
  isError504: boolean = true;

  tenant: string;
  imagePath: string;

  constructor(
    private translationService: TranslationService,
    private settingService: SettingService,
    private router: Router
  ) {
    if(!this.settingService.serverDown) {
      this.router.navigate(['/home']);
    }

    //const lang = (navigator.language || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';

    //this.translationService.setLanguage(lang);

    this.translationService.setLanguage(
      navigator.language?.toLowerCase().startsWith('fr') ? 'fr' : 'en'
    );
  }

  ngOnInit() {
    //this.tenant = localStorage.getItem('savedTenantRedirect');

    if(HttpHelpers.getSubdomain()) {
      this.tenant = HttpHelpers.getSubdomain();

      this.imagePath = `assets/errorPageImgs/${this.tenant}/icon.png`;
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }
}